import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import './CustomerCard.css'

function CustomerCard(props) {
    return (
        <div>
            <Card style={{ height: '40px', width: '100%' }} className={`customerCardBody ${props.selected}`} onClick={() => props.onClick(props.id)} >
                <CardContent style={{ padding: 10 }}>
                    <Typography variant="h6" component="div" style={{ cursor: "pointer", fontSize: '1rem', marginBottom: '5px', paddingTop: '3px' }}>{props.customer.cus_name}</Typography>
                </CardContent>
                <div>
                    {props.selected === 'active' && <i className="fas fa-chevron-right fa-2xs"></i>}
                </div>
            </Card>
        </div>
    )
}

export default CustomerCard;